import React from 'react';
import { Modal } from '@/ui-kit';
import { useAuth } from '@/store/useAuth';
import { FilterProfile } from './components/filter-profile';
import { useTranslation } from 'react-i18next';

interface Props {
    isOpen?: boolean;
    onClose?: () => void;
}

export const ModalProfileFilter: React.FC<Props> = ({ isOpen, onClose }) => {
    const userData = useAuth((state) => state.getUser());

    const { t } = useTranslation();

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            isDeskorTop={false}
            title={t('browse.filters')}>
            {userData && (
                <FilterProfile
                    onCloseModal={onClose}
                    userData={userData} />
            )}
        </Modal>
    );
};
